
<template>
  <div id="possession_finder" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-3" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined">
        <team-select v-model="team_selected" :options="team_dropdown" :preselectFirst="true" :allowEmpty="false" :inputFunc="changePlayers"></team-select>
      </div>

      <div class="col-md-1" v-if="off_def_dropdown.data != undefined">
        <label class="typo__label">{{ off_def_dropdown.label }}</label>
        <multiselect
          v-model="off_def_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="off_def_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div class="col-md-2" v-if="period_dropdown.data != undefined">
        <label class="typo__label">{{ period_dropdown.label }}</label>
        <multiselect
          v-model="period_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="false"
          placeholder=""
          :options="period_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="true">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div class="col-md-2" v-if="possession_start_dropdown.data != undefined">
        <possession-start-select v-model="possession_start_selected" :options="possession_start_dropdown"></possession-start-select>
      </div>

      <div class="col-md-2" v-if="leverage_dropdown.data != undefined && ($route.params.league == 'nba' || $route.params.league == 'wnba')">
        <label class="typo__label">{{ leverage_dropdown.label }}</label>
        <multiselect
          v-model="leverage_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :options="leverage_dropdown.data"
          :searchable="false"
          :show-labels="false"
          placeholder=""
          :preselect-first="false"
          :allow-empty="true"
          :close-on-select="false"
          :multiple="true">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
      </div>
    </div>

    <div class="border-padding">
      Score Margin:
      From: <input v-model="margin_from" placeholder="" maxlength="3" size="3">
      To: <input v-model="margin_to" placeholder="" maxlength="3" size="3">
      (Example: From -3 to -1 will get all possessions when the team was down by 3 points or less)
    </div>

    <div class="border-padding">
      Possession Start Time:
      From: <input v-model="possession_start_time_from" placeholder="" maxlength="3" size="3">
      To: <input v-model="possession_start_time_to" placeholder="" maxlength="3" size="3">
      (Enter time remaining in period in seconds. Ex. For last 2 minutes enter From 120 To 0)
    </div>

    <div v-if="number_of_filters >= 1">
      <div class="border-padding">
        <template v-for="filter in number_of_filters">
          <player-wowy-select
            v-bind:key="filter"
            :filter="filter"
            :number_type_options="number_type_dropdown"
            :number_of_players_options="number_of_players_dropdown"
            :player_options="players"
            :on_off_options="on_off_dropdown"
            :number_type="number_type_selected"
            :number_of_players="number_of_players_selected"
            :player_filter="players_selected"
            :on_off="on_off_selected"
            :filter_regex="player_filter_regex">
          </player-wowy-select>
        </template>
      </div>
    </div>
    <div class="border-padding">
      <div v-if="opponent_filter">
        <label class="typo__label">Opponent Filter</label>
        <multiselect
          v-model="opponents"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          placeholder="Select at least one"
          :options="team_dropdown.data"
          :searchable="false"
          :allow-empty="true"
          :close-on-select="false"
          :clear-on-select="true"
          :hide-selected="true"
          :preserve-search="true"
          :multiple="true">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
        <div v-if="opponent_players.length > 0">
            <div class="container-fluid">
              <label class="typo__label">Opponent Player Filter</label>
              <div class="row">
                <div>
                  <multiselect
                    v-model="opponent_number_type_selected"
                    select-label=""
                    deselect-label=""
                    track-by="id"
                    label="text"
                    :preselect-first="true"
                    :options="number_type_dropdown.data"
                    :searchable="false"
                    :show-labels="false"
                    :allow-empty="false">
                    <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
                  </multiselect>
                </div>

                <div>
                  <multiselect
                    v-model="opponent_number_of_players_selected"
                    select-label=""
                    deselect-label=""
                    track-by="id"
                    label="text"
                    :preselect-first="true"
                    :options="number_of_players_dropdown.data"
                    :searchable="false"
                    :show-labels="false"
                    :allow-empty="false">
                    <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
                  </multiselect>
                </div>

                <div>
                  <multiselect
                    v-model="opponent_players_selected"
                    :options="opponent_players"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    label="name"
                    track-by="playerId"
                    :preselect-first="false">
                    <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.name }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
                  </multiselect>
                </div>

                <div>
                  <multiselect
                    v-model="opponent_on_off_selected"
                    select-label=""
                    deselect-label=""
                    track-by="id"
                    label="text"
                    :preselect-first="true"
                    :options="[on_off_dropdown.data[0], on_off_dropdown.data[1]]"
                    :searchable="false"
                    :show-labels="false"
                    :allow-empty="false">
                    <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="border-padding">
      <div v-if="date_filter" class="container-fluid">
        <span>Date Filter</span>
        <div class="row">
          <span>From: </span>
          <datepicker placeholder="Select Date" v-model="from_date" name="from_date" format="yyyy-MM-dd"></datepicker>
          <span>To: </span>
          <datepicker placeholder="Select Date" v-model="to_date" name="to_date" format="yyyy-MM-dd"></datepicker>
        </div>
      </div>
    </div>
    <div class="border-padding">
      <button class="" v-on:click="addPlayerFilter">Add Player Filter</button>
      <button v-if="!opponent_filter" v-on:click="addOpponentFilter">Add Opponent Filter</button>
      <button v-if="opponent_filter" v-on:click="removeOpponentFilter">Remove Opponent Filter</button>
      <button v-if="!date_filter" v-on:click="addDateFilter">Add Date Filter</button>
      <button v-if="date_filter" v-on:click="removeDateFilter">Remove Date Filter</button>
      <button v-if="!rebound_player_filter && possession_start_selected != undefined && off_def_selected != undefined && (possession_start_selected.id.includes('Miss') || possession_start_selected.id.includes('Block')) && off_def_selected.id == 'Offense'" v-on:click="addReboundPlayerFilter">Add Rebound Player Filter</button>
      <button v-if="rebound_player_filter" v-on:click="removeReboundFilter">Remove Rebound Player Filter</button>
      <button v-if="!shot_player_filter && possession_start_selected != undefined && off_def_selected != undefined && (possession_start_selected.id.includes('Miss') || possession_start_selected.id.includes('Block') || possession_start_selected.id.includes('Make')) && off_def_selected.id == 'Defense'" v-on:click="addShotPlayerFilter">Add Shot Player Filter</button>
      <button v-if="shot_player_filter" v-on:click="removeShotFilter">Remove Shot Player Filter</button>
      <button v-if="!turnover_player_filter && possession_start_selected != undefined && off_def_selected != undefined && possession_start_selected.id == 'OffLiveBallTurnover'  && off_def_selected.id == 'Defense'" v-on:click="addTurnoverPlayerFilter">Add Turnover Player Filter</button>
      <button v-if="turnover_player_filter" v-on:click="removeTurnoverFilter">Remove Turnover Player Filter</button>
      <button v-if="!steal_player_filter && possession_start_selected != undefined && off_def_selected != undefined && possession_start_selected.id == 'OffLiveBallTurnover'  && off_def_selected.id == 'Offense'" v-on:click="addStealPlayerFilter">Add Steal Player Filter</button>
      <button v-if="steal_player_filter" v-on:click="removeStealFilter">Remove Steal Player Filter</button>
      <button v-if="!event_filter && off_def_selected != undefined && off_def_selected.id == 'Offense'" v-on:click="addEventFilter">Add Event Filter</button>
      <button v-if="event_filter" v-on:click="removeEventFilter">Remove Event Filter</button>
    </div>

    <div class="col-md-2" v-if="shot_player_filter">
      <player-select v-model="shot_player_selected" :options="players" label="Shot Player"></player-select>
    </div>

    <div class="col-md-2" v-if="rebound_player_filter">
      <player-select v-model="rebound_player_selected" :options="players" label="Rebound Player"></player-select>
    </div>

    <div class="col-md-2" v-if="turnover_player_filter">
      <player-select v-model="turnover_player_selected" :options="players" label="Turnover Player"></player-select>
    </div>

    <div class="col-md-2" v-if="steal_player_filter">
      <player-select v-model="steal_player_selected" :options="players" label="Steal Player"></player-select>
    </div>

    <div class="col-md-3" v-if="event_filter">
      <p>Gets stats for all possessions where the event type occurs</p>
      <label class="typo__label">Event Type</label>
        <multiselect
          v-model="event_type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="event_type_dropdown"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      <player-select v-model="event_player_selected" :options="players" label="Event Player"></player-select>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Get Possessions</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data_options.length > 0">
      <div class="col-md-2 border-padding">
        <stat-table-select v-model="stat_table_selected" :options="table_data_options"></stat-table-select>
      </div>
      <div v-if="totals_table_data.Points != undefined && stat_table_selected != undefined">
        <div>
          <button type="button" @click="copyDirectLink">Copy Direct Link To Table</button>
        </div>
        <h2>Totals</h2>

        <vue-good-table
          :columns="totals_table_columns[stat_table_selected.id]"
          :rows="[totals_table_data]"
          :sort-options="{ enabled: false }"
          styleClass="vgt-table bordered striped">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.formattedRow[props.column.field] == ''">
              0
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
              {{props.column.label}}
            </span>
            <span v-else>
              {{props.column.label}}
            </span>
          </template>
        </vue-good-table>

        <h2>Player Stats</h2>
        <vue-good-table
          :columns="player_table_columns[stat_table_selected.id]"
          :rows="player_table_data"
          :pagination-options="{ enabled: true, perPage: 30}"
          :searchOptions="{ enabled: false}"
          :sort-options="{ enabled: true, initialSortBy: {field: 'Name', type: 'asc'}}"
          styleClass="vgt-table bordered striped">
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'Name'">
              <span :id="'popover-' + props.row.EntityId+'-' + stat_table_selected.id" v-b-tooltip.hover title="Click For More">
                {{props.formattedRow[props.column.field]}}
              </span>
              <b-popover
                :target="'popover-' + props.row.EntityId+'-' + stat_table_selected.id">
                <template slot="title">{{props.row.Name}}</template>
                <ul>
                  <li><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'player' }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId}}">Game Logs</router-link></li>
                </ul>
              </b-popover>
            </div>
            <div v-else>
              <span v-b-tooltip.hover :title="props.formattedRow['Name']">
                {{props.formattedRow[props.column.field]}}
              </span>
            </div>
          </template>
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
              {{props.column.label}}
            </span>
            <span v-else>
              {{props.column.label}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <div v-if="possession_table_data.length > 0">
      <h2>Possession Details</h2>
      <span v-if="player_table_data.length == 500" style="font-size: 10pt">If there are more than 500 results, only the top 500 in minutes played will be shown in table</span>
      <vue-good-table
        :columns="possession_table_columns"
        :rows="possession_table_data"
        :pagination-options="{ enabled: true, perPage: 30}"
        styleClass="vgt-table bordered striped">
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field == 'Events'">
            <span v-if="props.row['VideoUrls'].length > 0" v-b-tooltip.hover :id="'popover-video-' + props.formattedRow.Opponent + props.formattedRow.Period + props.formattedRow.StartTime">
              <ul>
                <template v-for="event in props.row['VideoUrls']">
                  <li v-if="event.url != ''" v-bind:key="event.url"><a :href="event.url" target="_blank">{{event.description}}</a></li>
                  <li v-else v-bind:key="event.description">{{event.description}}</li>
                </template>
              </ul>
            </span>
            <span v-else v-b-tooltip.hover :id="'popover-video-' + props.formattedRow.Opponent + props.formattedRow.Period + props.formattedRow.StartTime"></span>
          </div>
          <div v-else-if="props.formattedRow[props.column.field] == ''">
            <span v-b-tooltip.hover :id="'popover-' + props.formattedRow.Opponent + props.formattedRow.Period + props.formattedRow.StartTime" :title="props.row['Events']">
              0
            </span>
          </div>
          <div v-else>
            <span v-b-tooltip.hover :id="'popover-' + props.formattedRow.Opponent + props.formattedRow.Period + props.formattedRow.StartTime" :title="props.row['Events']">
              {{props.formattedRow[props.column.field]}}
            </span>
          </div>
        </template>
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
            {{props.column.label}}
          </span>
          <span v-else>
            {{props.column.label}}
          </span>
        </template>
      </vue-good-table>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import { rateStats } from './mixins/rate_stats'
import { tableDataOptions } from './mixins/table_data_options'
import { tableUtils } from './mixins/table_utils'
import { possessionFinderHeaders } from './mixins/table_headers'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import PossessionStartSelect from './mixins/PossessionStartSelect.vue'
import PlayerWowySelect from './mixins/PlayerWowySelect.vue'
import PlayerSelect from './mixins/PlayerSelect.vue'
import StatTableSelect from './mixins/StatTableSelect.vue'
import { season, seasonType, possessionFinderOnOff, numberType, numberOfPlayers, period, starterState, leverage, startType } from './mixins/dropdowns'

export default {
  name: 'PossessionFinder',
  components: {
    Multiselect,
    Datepicker,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PossessionStartSelect,
    PlayerWowySelect,
    PlayerSelect,
    StatTableSelect
  },
  mixins: [
    rateStats,
    tableDataOptions,
    tableUtils,
    possessionFinderHeaders,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PossessionStartSelect,
    PlayerWowySelect,
    PlayerSelect,
    StatTableSelect,
    GetDropdownOptions,
    season,
    seasonType,
    possessionFinderOnOff,
    numberType,
    numberOfPlayers,
    period,
    starterState,
    leverage,
    startType
  ],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      team_dropdown: {},
      team: undefined,
      on_off_dropdown: {},
      on_off_selected: [],
      number_type_dropdown: {},
      number_type_selected: [],
      number_of_players_dropdown: {},
      number_of_players_selected: [],
      off_def_dropdown: {},
      off_def_selected: undefined,
      possession_start_dropdown: {},
      possession_start_selected: undefined,
      leverage_dropdown: {},
      leverage_selected: [],
      players: [],
      number_of_filters: 0,
      players_selected: [],
      players_selected_strings: [],
      period_dropdown: {},
      period_selected: undefined,
      opponent_filter: false,
      opponents: [],
      date_filter: false,
      to_date: undefined,
      from_date: undefined,
      margin_from: undefined,
      margin_to: undefined,
      possession_start_time_from: undefined,
      possession_start_time_to: undefined,
      possession_length_gte: undefined,
      possession_length_lte: undefined,
      shot_player_filter: false,
      shot_player_selected: undefined,
      rebound_player_filter: false,
      rebound_player_selected: undefined,
      turnover_player_filter: false,
      turnover_player_selected: undefined,
      steal_player_filter: false,
      steal_player_selected: undefined,
      event_filter: false,
      event_type_selected: undefined,
      event_player_selected: undefined,
      event_type_dropdown: [{'id': 'FG2A', 'text': '2pt FGA'}, {'id': 'FG3A', 'text': '3pt FGA'}, {'id': 'Oreb', 'text': 'Offensive Rebound'}],
      table_data_options: [],
      stat_table_selected: undefined,
      totals_table_data: [],
      totals_table_columns: {},
      player_table_data: [],
      player_table_columns: {},
      possession_table_data: [],
      possession_table_columns: {},
      use_min_filters: false,
      use_text_filters: false,
      team_player_or_opponent: undefined,
      show_error_message: false,
      opponent_players: [],
      opponent_number_type_selected: undefined,
      opponent_number_of_players_selected: undefined,
      opponent_players_selected: [],
      opponent_on_off_selected: undefined,
      direct_link: '',
      api_endpoint: 'get-possessions/',
      player_filter_regex: /^\d(Exactly|GreaterThan|LessThan)\d(OnFloor|OffFloor|PlayedInGame|DidNotPlayInGame)/i,
      opponent_player_filter_regex: /^Opponent(Exactly|GreaterThan|LessThan)\d(OnFloor|OffFloor)/i
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague',
    'off_def_selected': 'removePlayerFilter',
    'possession_start_selected': 'removePlayerFilter',
    'stat_table_selected': 'updateDirectLink',
    'opponents': 'updateOpponentPlayers'
  },
  methods: {
    changeLeague () {
      this.totals_table_data = []
      this.player_table_data = []
      this.players_selected = []
      this.seasons_selected = []
      this.opponent_filter = false
      this.opponents = []
      this.number_type_selected = []
      this.number_of_players_selected = []
      this.on_off_selected = []
      this.leverage_selected = []
      this.date_filter = false
      this.to_date = undefined
      this.from_date = undefined
      this.number_of_filters = 0
      this.opponent_players = []
      this.opponent_number_type_selected = undefined
      this.opponent_number_of_players_selected = undefined
      this.opponent_players_selected = []
      this.opponent_on_off_selected = undefined
      this.removeShotFilter()
      this.removeReboundFilter()
      this.removeEventFilter()
      this.$router.push({name: 'possession_finder', params: {league: this.$parent.league, type: this.$route.params.type}})
    },
    setDropdown () {
      this.possession_start_dropdown = this.start_type_dropdown_options
      this.off_def_dropdown = {
        'label': 'Off/Def',
        'data': [
          {'id': 'Offense', 'text': 'Off'},
          {'id': 'Defense', 'text': 'Def'}
        ]
      }
      this.on_off_dropdown = this.possession_finder_on_off_dropdown_options
      this.number_type_dropdown = this.number_type_dropdown_options
      this.number_of_players_dropdown = this.number_of_players_dropdown_options
      this.period_dropdown = this.period_dropdown_options
      this.leverage_dropdown = this.leverage_dropdown_options

      this.period_dropdown.data.forEach((period) => {
        if (period.id === this.$route.query.Period) {
          this.period_selected = period
        }
      })

      this.off_def_dropdown.data.forEach((offDef) => {
        if (offDef.id === this.$route.query.OffDef) {
          this.off_def_selected = offDef
        }
      })

      this.setPossessionStartType()

      if (this.$route.query.FromMargin) {
        this.margin_from = this.$route.query.FromMargin
      }
      if (this.$route.query.ToMargin) {
        this.margin_to = this.$route.query.ToMargin
      }
      if (this.$route.query.FromTime) {
        this.possession_start_time_from = this.$route.query.FromTime
      }
      if (this.$route.query.ToTime) {
        this.possession_start_time_to = this.$route.query.ToTime
      }
      if (this.$route.query.PossessionLengthGte) {
        this.possession_length_gte = this.$route.query.PossessionLengthGte
      }
      if (this.$route.query.PossessionLengthLte) {
        this.possession_length_lte = this.$route.query.PossessionLengthLte
      }
      if (this.$route.query.Opponent) {
        this.addOpponentFilter()

        this.opponent_team_ids = this.$route.query.Opponent.split(',')

        this.team_dropdown.data.forEach((team) => {
          this.opponent_team_ids.forEach((opponentTeamId) => {
            if (team.id === opponentTeamId) {
              this.opponents.push(team)
            }
          })
        })
        this.updateOpponentPlayers([this.addOpponentFiltersFromQueryParams])
      }
      if (this.$route.query.ToDate || this.$route.query.FromDate) {
        this.addDateFilter()
        var filterDate
        if (this.$route.query.ToDate) {
          filterDate = this.$route.query.ToDate.split('-')
          this.to_date = new Date(parseInt(filterDate[0]), parseInt(filterDate[1]) - 1, parseInt(filterDate[2]))
        }
        if (this.$route.query.FromDate) {
          filterDate = this.$route.query.FromDate.split('-')
          this.from_date = new Date(parseInt(filterDate[0]), parseInt(filterDate[1]) - 1, parseInt(filterDate[2]))
        }
      }
      var callbackFunctions = []
      Object.keys(this.$route.query).forEach((key) => {
        if (key.match(this.player_filter_regex) !== null) {
          callbackFunctions.push(this.addFiltersFromQueryParams)
        }
      })
      if (this.$route.query.ShooterPlayerId && this.possession_start_selected && this.off_def_selected && (this.possession_start_selected.id.includes('Miss') || this.possession_start_selected.id.includes('Block') || this.possession_start_selected.id.includes('Make')) && this.off_def_selected.id === 'Defense') {
        callbackFunctions.push(this.addShotPlayerFilter)
      }
      if (this.$route.query.ReboundPlayerId && this.possession_start_selected && this.off_def_selected && (this.possession_start_selected.id.includes('Miss') || this.possession_start_selected.id.includes('Block')) && this.off_def_selected.id === 'Offense') {
        callbackFunctions.push(this.addReboundPlayerFilter)
      }
      if (this.$route.query.TurnoverPlayerId && this.possession_start_selected && this.off_def_selected && this.possession_start_selected.id === 'OffLiveBallTurnover' && this.off_def_selected.id === 'Defense') {
        callbackFunctions.push(this.addTurnoverPlayerFilter)
      }
      if (this.$route.query.StealPlayerId && this.possession_start_selected && this.off_def_selected && this.possession_start_selected.id === 'OffLiveBallTurnover' && this.off_def_selected.id === 'Offense') {
        callbackFunctions.push(this.addStealPlayerFilter)
      }
      if (this.$route.query.EventPlayerId && this.off_def_selected && this.off_def_selected.id === 'Offense') {
        callbackFunctions.push(this.addEventFilter)
      }

      if (this.$route.query.EventType && this.off_def_selected && this.off_def_selected.id === 'Offense') {
        this.event_type_dropdown.forEach((eventType) => {
          if (eventType.id === this.$route.query.EventType) {
            this.event_type_selected = eventType
          }
        })
      }

      if (this.$route.query.Leverage) {
        var leverage = this.$route.query.Leverage.split(',')

        this.leverage_dropdown.data.forEach((leverageItem) => {
          leverage.forEach((leverageQueryItem) => {
            if (leverageItem.id === leverageQueryItem) {
              this.leverage_selected.push(leverageItem)
            }
          })
        })
      }

      if (this.$route.query.TeamId && this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.OffDef) {
        if (callbackFunctions.length > 0) {
          this.getPlayers(callbackFunctions)
        }
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTeamDropdown, this.setDropdown])
    },
    updateData () {
      if (this.$route.query.TeamId && this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.OffDef) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    addOpponentFiltersFromQueryParams () {
      Object.keys(this.$route.query).forEach((key) => {
        if (key.match(this.opponent_player_filter_regex) !== null) {
          var match = key.match(this.opponent_player_filter_regex)
          var opponentPlayersIds = this.$route.query[key].split(',')

          var filterNumberType = match[1]
          this.number_type_dropdown.data.forEach((numberType) => {
            if (numberType.id === filterNumberType) {
              this.opponent_number_type_selected = numberType
            }
          })

          var filterOnOff = match[2]
          this.on_off_dropdown.data.forEach((onOff) => {
            if (onOff.id === filterOnOff) {
              this.opponent_on_off_selected = onOff
            }
          })

          var numberOfPlayers = key.split(filterNumberType)[1].split(filterOnOff)[0]
          this.number_of_players_dropdown.data.forEach((numberOfPlayersOption) => {
            if (numberOfPlayersOption.id === numberOfPlayers) {
              this.opponent_number_of_players_selected = numberOfPlayersOption
            }
          })

          opponentPlayersIds.forEach((filterPlayerId) => {
            this.opponent_players.forEach((player) => {
              if (player.playerId === filterPlayerId) {
                this.opponent_players_selected.push(player)
              }
            })
          })
        }
      })
    },
    changePlayers () {
      this.players_selected = []
      this.number_of_filters = 0
      this.season_selected_string = this.getSeasonsSelectedString()
      this.number_of_players_selected = []
      this.on_off_selected = []
      this.number_type_selected = []
      if (this.number_of_filters === 0) {
        this.getPlayers([this.addFiltersFromQueryParams])
      }
      this.removeShotFilter()
      this.removeReboundFilter()
      this.removeStealFilter()
      this.removeTurnoverFilter()
      this.removeEventFilter()
    },
    addPlayerFilter () {
      if (this.number_of_filters === 0) {
        this.changePlayers()
      } else {
        this.number_of_filters += 1
      }
    },
    addOpponentFilter () {
      if (!this.opponent_filter) {
        this.opponent_filter = true
      }
    },
    updateOpponentPlayers (callbacks) {
      if (this.opponents.length > 0) {
        callbacks = callbacks || [function () {}]
        this.season_selected_string = this.getSeasonsSelectedString()

        var opponentTeamIds = ''
        for (var j = 0; j < this.opponents.length; j++) {
          if (j === 0) {
            opponentTeamIds += this.opponents[j].id
          } else {
            opponentTeamIds += ',' + this.opponents[j].id
          }
        }

        var params = {}
        params[this.$teamIdParam] = opponentTeamIds
        params[this.$seasonParam] = this.season_selected_string
        params[this.$seasonTypeParam] = this.season_type_selected.id

        axios.get(process.env.API_BASE_URL + 'get-team-players-for-season', {
          params: params
        })
          .then((response) => {
            this.player_ids = Object.keys(response.data.players)
            this.loading = false
            this.opponent_players = []
            this.player_ids.forEach((playerId) => {
              this.opponent_players.push({'playerId': playerId, 'name': response.data.players[playerId]})
            })
            // remove players if they are not in opponent_players
            for (var i = 0; i < this.opponent_players_selected.length; i++) {
              if (this.player_ids.indexOf(this.opponent_players_selected[0].playerId) === -1) {
                this.opponent_players_selected.splice(i, 1)
                i--
              }
            }
            callbacks.forEach((callback) => {
              if (typeof callback === 'function') {
                callback()
              }
            })
          }, (error) => {
            this.loading = false
            this.error = error
          })
      } else {
        this.opponent_players = []
      }
    },
    addDateFilter () {
      if (!this.date_filter) {
        this.date_filter = true
      }
    },
    removeDateFilter () {
      this.date_filter = false
      this.to_date = undefined
      this.from_date = undefined
    },
    removeOpponentFilter () {
      this.opponent_filter = false
      this.opponents = []
    },
    removePlayerFilter () {
      if (!(this.possession_start_selected && this.off_def_selected && (this.possession_start_selected.id.includes('Miss') || this.possession_start_selected.id.includes('Block') || this.possession_start_selected.id.includes('Make')) && this.off_def_selected.id === 'Defense')) {
        this.removeShotFilter()
      }
      if (!(this.possession_start_selected && this.off_def_selected && (this.possession_start_selected.id.includes('Miss') || this.possession_start_selected.id.includes('Block')) && this.off_def_selected.id === 'Offense')) {
        this.removeReboundFilter()
      }
      if (!(this.possession_start_selected && this.off_def_selected && this.possession_start_selected.id === 'OffLiveBallTurnover' && this.off_def_selected.id === 'Defense')) {
        this.removeTurnoverFilter()
      }
      if (!(this.possession_start_selected && this.off_def_selected && this.possession_start_selected.id === 'OffLiveBallTurnover' && this.off_def_selected.id === 'Offense')) {
        this.removeStealFilter()
      }

      this.removeEventFilter()
    },
    addReboundPlayerFilter () {
      if (!this.rebound_player_filter) {
        this.rebound_player_filter = true
        if (this.players.length === 0) {
          this.getPlayers([this.setReboundPlayerId])
        } else {
          this.setReboundPlayerId()
        }
      }
      this.removeShotFilter()
      this.removeStealFilter()
      this.removeTurnoverFilter()
    },
    removeReboundFilter () {
      this.rebound_player_filter = false
      this.rebound_player_selected = undefined
    },
    removeShotFilter () {
      this.shot_player_filter = false
      this.shot_player_selected = undefined
    },
    removeTurnoverFilter () {
      this.turnover_player_filter = false
      this.turnover_player_selected = undefined
    },
    removeStealFilter () {
      this.steal_player_filter = false
      this.steal_player_selected = undefined
    },
    addShotPlayerFilter () {
      if (!this.shot_player_filter) {
        this.shot_player_filter = true
        if (this.players.length === 0) {
          this.getPlayers([this.setShooterPlayerId])
        } else {
          this.setShooterPlayerId()
        }
      }
      this.removeReboundFilter()
      this.removeStealFilter()
      this.removeTurnoverFilter()
    },
    addTurnoverPlayerFilter () {
      if (!this.turnover_player_filter) {
        this.turnover_player_filter = true
        if (this.players.length === 0) {
          this.getPlayers([this.setTurnoverPlayerId])
        } else {
          this.setTurnoverPlayerId()
        }
      }
      this.removeReboundFilter()
      this.removeShotFilter()
      this.removeStealFilter()
    },
    addStealPlayerFilter () {
      if (!this.steal_player_filter) {
        this.steal_player_filter = true
        if (this.players.length === 0) {
          this.getPlayers([this.setStealPlayerId])
        } else {
          this.setStealPlayerId()
        }
      }
      this.removeReboundFilter()
      this.removeShotFilter()
      this.removeTurnoverFilter()
    },
    removeEventFilter () {
      this.event_filter = false
      this.event_player_selected = undefined
    },
    addEventFilter () {
      if (!this.event_filter) {
        this.event_filter = true
        if (this.players.length === 0) {
          this.getPlayers([this.setEventPlayerId])
        } else {
          this.setEventPlayerId()
        }
      }
      this.removeReboundFilter()
    },
    setShooterPlayerId () {
      if (this.$route.query.ShooterPlayerId) {
        this.players.forEach((player) => {
          if (player.playerId === this.$route.query.ShooterPlayerId) {
            this.shot_player_selected = player
          }
        })
      }
    },
    setReboundPlayerId () {
      if (this.$route.query.ReboundPlayerId) {
        this.players.forEach((player) => {
          if (player.playerId === this.$route.query.ReboundPlayerId) {
            this.rebound_player_selected = player
          }
        })
      }
    },
    setTurnoverPlayerId () {
      if (this.$route.query.TurnoverPlayerId) {
        this.players.forEach((player) => {
          if (player.playerId === this.$route.query.TurnoverPlayerId) {
            this.turnover_player_selected = player
          }
        })
      }
    },
    setStealPlayerId () {
      if (this.$route.query.StealPlayerId) {
        this.players.forEach((player) => {
          if (player.playerId === this.$route.query.StealPlayerId) {
            this.steal_player_selected = player
          }
        })
      }
    },
    setEventPlayerId () {
      if (this.$route.query.EventPlayerId) {
        this.players.forEach((player) => {
          if (player.playerId === this.$route.query.EventPlayerId) {
            this.event_player_selected = player
          }
        })
      }
    },
    getLeverageString () {
      var leverageString = ''
      for (var i = 0; i < this.leverage_selected.length; i++) {
        if (i === 0) {
          leverageString += this.leverage_selected[i].id
        } else {
          leverageString += ',' + this.leverage_selected[i].id
        }
      }
      return leverageString
    },
    setLeverageSelected () {
      this.leverage_selected = []
      if (this.$route.query.Leverage) {
        this.leverage_dropdown.data.forEach((leverageOption) => {
          this.$route.query.Leverage.split(',').forEach((leverageSelected) => {
            if (leverageOption.id === leverageSelected) {
              this.leverage_selected.push(leverageOption)
            }
          })
        })
      }
    },
    changeStats () {
      this.query_params = {}
      this.getPlayersSelected()
      for (var i = 0; i < this.players_selected_strings.length; i++) {
        this.filter_type = i.toString() + this.number_type_selected[i].id + this.number_of_players_selected[i].id + this.on_off_selected[i].id
        this.query_params[this.filter_type] = this.players_selected_strings[i]
      }

      this.opponent_team_ids_string = ''
      for (var j = 0; j < this.opponents.length; j++) {
        if (j === 0) {
          this.opponent_team_ids_string += this.opponents[j].id
        } else {
          this.opponent_team_ids_string += ',' + this.opponents[j].id
        }
      }
      this.season_selected_string = this.getSeasonsSelectedString()

      this.query_params[this.$teamIdParam] = this.team_selected.id
      this.query_params[this.$seasonParam] = this.season_selected_string
      this.query_params[this.$seasonTypeParam] = this.season_type_selected.id
      this.query_params[this.$offDefParam] = this.off_def_selected.id
      if (!this.possession_start_selected) {
        this.possession_start_selected = this.possession_start_dropdown.data[0]
      }
      this.query_params[this.$startTypeParam] = this.possession_start_selected.id

      if (this.opponent_filter && this.opponent_team_ids_string !== '') {
        this.query_params['Opponent'] = this.opponent_team_ids_string
        if (this.opponent_players_selected.length > 0) {
          var opponentPlayerIds = ''
          for (var k = 0; k < this.opponent_players_selected.length; k++) {
            if (k === 0) {
              opponentPlayerIds += this.opponent_players_selected[k].playerId
            } else {
              opponentPlayerIds += ',' + this.opponent_players_selected[k].playerId
            }
          }
          var opponentFilterType = 'Opponent' + this.opponent_number_type_selected.id + this.opponent_number_of_players_selected.id + this.opponent_on_off_selected.id
          this.query_params[opponentFilterType] = opponentPlayerIds
        }
      }
      if (this.from_date) {
        this.query_params[this.$fromDateParam] = this.from_date.toISOString().split('T')[0]
      }
      if (this.to_date) {
        this.query_params[this.$toDateParam] = this.to_date.toISOString().split('T')[0]
      }
      if (this.margin_from && this.margin_from !== '') {
        this.query_params[this.$fromMarginParam] = this.margin_from
      }
      if (this.margin_to && this.margin_to !== '') {
        this.query_params[this.$toMarginParam] = this.margin_to
      }
      if (this.possession_start_time_from && this.possession_start_time_from !== '') {
        this.query_params[this.$fromTimeParam] = this.possession_start_time_from
      }
      if (this.possession_start_time_to && this.possession_start_time_to !== '') {
        this.query_params[this.$toTimeParam] = this.possession_start_time_to
      }
      if (this.possession_length_gte && this.possession_length_gte !== '') {
        this.query_params[this.$possessionLengthGte] = this.possession_length_gte
      }
      if (this.possession_length_lte && this.possession_length_lte !== '') {
        this.query_params[this.$possessionLengthLte] = this.possession_length_lte
      }
      if (this.period_selected && this.period_selected !== null) {
        this.query_params[this.$periodParam] = this.period_selected.id
      }

      if (this.rebound_player_filter && this.rebound_player_selected) {
        this.query_params['ReboundPlayerId'] = this.rebound_player_selected.playerId
      }

      if (this.shot_player_filter && this.shot_player_selected) {
        this.query_params['ShooterPlayerId'] = this.shot_player_selected.playerId
      }

      if (this.turnover_player_filter && this.turnover_player_selected) {
        this.query_params['TurnoverPlayerId'] = this.turnover_player_selected.playerId
      }

      if (this.steal_player_filter && this.steal_player_selected) {
        this.query_params['StealPlayerId'] = this.steal_player_selected.playerId
      }

      if (this.event_filter && this.event_player_selected && this.event_type_selected) {
        this.query_params['EventType'] = this.event_type_selected.id
        this.query_params['EventPlayerId'] = this.event_player_selected.playerId
      }

      if (this.leverage_selected.length > 0) {
        this.query_params[this.$leverageParam] = this.getLeverageString()
      }

      this.$router.push({name: 'possession_finder', query: this.query_params})
    },
    getStats () {
      this.show_error_message = false
      this.loading = true
      this.totals_table_data = []
      this.player_table_data = []
      this.possession_table_data = []

      axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
        params: this.$route.query
      })
        .then((response) => {
          if (!response.data.error) {
            this.team_player_or_opponent = this.$route.query.Type

            this.table_data_options = this.base_table_options

            this.totals_table_data = response.data.team_results
            this.totals_table_columns = this.team_headers

            this.player_table_data = response.data.player_results
            if (this.$route.query.OffDef.toLowerCase() === 'offense') {
              var playerHeaders = this.player_off_headers
            } else {
              playerHeaders = this.player_def_headers
            }
            this.player_table_columns = playerHeaders

            this.possession_table_data = response.data.possessions
            this.possession_table_columns = this.possession_headers

            this.player_table_data.forEach((lineupRow) => {
              this.table_data_options.forEach((tableDataOption) => {
                var values = this.setZerosAndSortFunction(this.player_table_columns[tableDataOption.id], lineupRow)
                lineupRow = values.row
                this.player_table_columns[tableDataOption.id] = values.columns
              })
            })
            if (this.$route.query.Table) {
              this.setStatTableSelected()
            }
            this.updateDirectLink()
          } else {
            this.show_error_message = true
          }
          this.loading = false
        }, (error) => {
          this.show_error_message = true
          this.loading = false
          this.error = error
        })
    },
    copyDirectLink: function () {
      this.$copyText(this.direct_link)
    },
    updateDirectLink () {
      var query = this.$route.query

      if (this.stat_table_selected) {
        query['Table'] = this.stat_table_selected.id
      }

      var queryString = Object.keys(query).map(function (key) {
        return key + '=' + query[key]
      }).join('&')

      this.direct_link = window.location.origin + this.$route.path + '?' + queryString
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/PossessionFinder.vue